module.exports = __webpack_public_path__ + "media/images/icons/auth_success-b85d80c6680f5ab918c6313619d4104e.svg";